import React from 'react';
import {connect} from 'react-redux';

import Container from '../components/Container';
import SectionTitle from '../components/SectionTitle';
import ParseHTML from '../components/ParseHTML';
import Button from '../components/Button';

if (process.env.BROWSER) {
    var scrollToElement = require('scroll-to-element');
    require('flexboxgrid');
}

const AboutUs = React.createClass({
    propTypes: {
        contact_position: React.PropTypes.string,
        title: React.PropTypes.string.isRequired,
        description: React.PropTypes.string,
        image: React.PropTypes.string,
        opening_title: React.PropTypes.string,
        opening_times: React.PropTypes.string,
        address_title: React.PropTypes.string,
        street: React.PropTypes.string,
        number: React.PropTypes.string,
        plz: React.PropTypes.string,
        ort: React.PropTypes.string,
        tel: React.PropTypes.string,
        fax: React.PropTypes.string,
        email: React.PropTypes.string,
        textContact: React.PropTypes.string,
        textJourney: React.PropTypes.string,
        iconContact: React.PropTypes.string,
        iconJourney: React.PropTypes.string,
        iconContactHidden: React.PropTypes.bool,
        iconJourneyHidden: React.PropTypes.bool
    },
    _scrollAnfahrt: function() {
        scrollToElement("#jobslink", {
            ease: "linear",
            duration: 600,
        });
    },
    _scrollContact: function() {
        scrollToElement('#contact-form', {
            ease: 'linear',
            duration: 600
        });
    },
    render: function() {
        return (
            <Container>
                <SectionTitle>
                    <ParseHTML>{this.props.title}</ParseHTML>
                </SectionTitle>
                {this.props.contact_position == 'about' ? (
                    <div className="row">
                        <div className="col-xs-12 col-md-4">
                            <ParseHTML>{this.props.description}</ParseHTML>
                        </div>
                        <div className="col-xs-12 col-md-4 center-xs">
                            <img src={this.props.image} alt={this.props.title} />
                        </div>
                        <div className="col-xs-12 col-md-4">
                            <p>
                                <b>{this.props.opening_title}</b>
                                <br />
                                <ParseHTML>{this.props.opening_times}</ParseHTML>
                            </p>
                            <hr />
                            <p>
                                <b>{this.props.address_title}</b>
                                <br />
                                <span>
                                    {this.props.street} {this.props.number}
                                </span>
                                <br />
                                <span>
                                    {this.props.plz} {this.props.ort}
                                </span>
                                <br />
                            </p>
                            <p>
                                <span>Tel. {this.props.tel}</span>
                                <br />
                                <span>Fax {this.props.fax}</span>
                                <br />
                                <span>
                                    E-Mail:{' '}
                                    <a href={`mailto:${this.props.email}`}>{this.props.email}</a>
                                </span>
                            </p>
                            {!this.props.iconContactHidden ? (
                                <Button click={this._scrollContact} icon={this.props.iconContact}>
                                    {this.props.textContact}
                                </Button>
                            ) : null}
                            {!this.props.iconJourneyHidden ? (
                                <Button click={this._scrollAnfahrt} icon={this.props.iconJourney}>
                                    {this.props.textJourney}
                                </Button>
                            ) : null}
                        </div>
                    </div>
                ) : (
                    <div className="row margin-about">
                        <div className="col-xs-12 col-md-6">
                            <ParseHTML>{this.props.description}</ParseHTML>
                        </div>
                        <div className="col-xs-12 col-md-6 center-xs end-md">
                            <img src={this.props.image} alt={this.props.title} />
                        </div>
                    </div>
                )}
            </Container>
        );
    }
});

const mapStateToProps = state => {
    return {
        contact_position: state.company.contact_position,
        title: state.about_us.title,
        description: state.about_us.description,
        image: state.about_us.image,
        opening_title: state.company.opening_times.title,
        opening_times: state.company.opening_times.text,
        address_title: state.company.address.title,
        street: state.company.address.street,
        number: state.company.address.number,
        plz: state.company.address.plz,
        ort: state.company.address.ort,
        tel: state.company.address.tel,
        fax: state.company.address.fax,
        email: state.company.address.email,
        textContact: state.company.address.toContactForm.text,
        iconContact: state.company.address.toContactForm.icon,
        iconContactHidden: state.company.address.toContactForm.hidden,
        textJourney: state.company.address.toJourney.text,
        iconJourney: state.company.address.toJourney.icon,
        iconJourneyHidden: state.company.address.toJourney.hidden
    };
};

export default connect(mapStateToProps)(AboutUs);



// WEBPACK FOOTER //
// ./src/js/containers/AboutUs.js